module.exports = __webpack_public_path__ + "img/logo-icon3.04065168.png";